// 案件一覧（職員）の定数

// 検索条件「担当店舗」の初期値（0=全て）
export const store_in_charge_default = '0';
